const integrationsPath = "/integrations"
const apiKeyManagementPath = `${integrationsPath}/api-key-management`
const apiKeyManagementNewPath = `${integrationsPath}/api-key-management/new`

export { apiKeyManagementPath, apiKeyManagementNewPath }
